import { SignUpModes } from '../../constants';
import EmailVerificationForm from '../../forms/email-verification/EmailVerificationForm';

const EmailVerificationPage = () => {
    return (
        <section className='eh-page eh-page-email-verification'>
            <EmailVerificationForm mode={SignUpModes.STANDARD} />
        </section>
    );
};

export default EmailVerificationPage;
